module.exports = __webpack_public_path__ + "img/symbol_arrow2green.2bcbac3f.png";